// LEft Images import 
import about from "../images/about.jpg";
import AbuAzhar from "../images/abuazhar.jpg";
import contact from "../images/contact.jpg";
import project from "../images/project.jpg";
import resume from "../images/resume.jpg";

// Project Images Import 
import chatapp from '../images/chatapp.avif';
import homedoors from "../images/homedoors.avif";
import jantacons from "../images/jantacons.png";
import rishtewale from '../images/rishte.jpeg';
import webdeveloper from '../images/webdeveloper.avif';
import zenith from '../images/zenith.avif';

// TESO IMAGES IMPORT 
import ahmad from '../images/ahmad.avif';
import usman from '../images/usman.avif';
import wasif from '../images/wasif.avif';
import zoyef from '../images/zoyef.avif';

// ABOUT COMPONENT
export const aboutCards = [
  {
    id: 1,
    heading: "Front-End Framework",
    paragraph:
      "Now i am using to  to utilize front-end frameworks and libraries like React, Angular, or Vue.js to develop dynamic and interactive user interfaces.",
  },
  {
    id: 2,
    heading: "Responsive Design",
    paragraph:
      "I used to create captivating, mobile-friendly websites that engaged users on any device. Elevate your online presence in Saharanpur today!",
  },

  {
    id: 3,
    heading: "UI/UX Design",
    paragraph:
      "Proficient in UI and UX design, my focus lies in crafting seamless and visually appealing digital experiences. I aspire to leverage my comprehension of user behavior and psychology.          ",
  },
  {
    id: 4,
    heading: "Web Development",
    paragraph:
      "I am developing the front-end portion of websites and web applications using technologies like HTML, CSS, and JavaScript, as well as frontend frameworks like ReactJS.",
  },
];
export const navbar = [
  {
    id: 1,
    name: "WHO I AM",
    heading: "ABOUT ME",
  },

  {
    id: 2,
    name: "HISTORY",
    heading: "MY RESUME",
  },
  {
    id: 2,
    name: "LATEST WORK",
    heading: "MY PROJECTS",
  },
  {
    id: 2,
    name: "GET IN TOUCH",
    heading: "CONTACT ME",
  },
];

export const counter = [
  {
    id: 1,
    number: 20,
    discription: "HAPPY CLIENTS ",
  },
  {
    id: 2,
    number: 375,
    discription: "TELEPHONE TALK ",
  },
  {
    id: 3,
    number: 18,
    discription: "PROJECTS",
  },
  {
    id: 4,
    number: 2,
    discription: "EXPERIENCE",
  },
];

// RESUME COMPONENT
export const study = [
  {
    id: 1,
    company: "JANTA CONSTRUCTION WEBSITE",
    yearTime: "https://jantaconstruction.com",
    links:"https://jantaconstruction.com",
    para: "Developed user-friendly and modern website for Janta Construction, a real business. Utilized core technologies: HTML, CSS (Flexbox and Grid), and JavaScript for seamless user experience.Implemented Desktop First Approach and Responsive Design for optimal display on all devices.",
  },
  {
    id: 2,
    company: "ONLINE CHAT APP ",
    yearTime: "https://online-chatapp.netlify.app/",
    para: "Our chat app leverages Firebase's real-time database to deliver messages in real-time, ensuring your conversations flow seamlessly. our privacy is paramount. We've implemented Firebase's authentication and security features to ensure your conversations remain confidential and protected. ",
    links:"https://online-chatapp.netlify.app/",
  },
  {
    id: 3,
    company: "Matrimonial Website",
    yearTime: "https://rishtewale.com/",
    links:"https://rishtewale.com",
    para: "Embarking on the creation of Rishtewale.com has been a transformative journey, rich with learning and innovation. it was a passionate pursuit to provide users with a platform that transcends the ordinary in the quest for love and companionship. The fusion of HTML, CSS, and JavaScript has not only empowered the site with a sleek and intuitive interface but has also infused it with a dynamic and responsive design ",
  },
  {
    id:4,
    company:"Zenith Tobacco Machinery",
    links:"https://ztm.co.in/",
    yearTime:"https://ztm.co.in/",
    para:"I have recently created a website showcasing cigarette making machinery for international sales, using HTML, CSS, and JavaScript. Through this experience, I have gained valuable insights into web development and design. The website serves as a platform for presenting and promoting high-quality cigarette manufacturing equipment on a global scale."
  },
  {
    id: 5,
    company: "MS University (Saharanpur)",
    yearTime: "JUN 2021 - DEC 2024",
    para: "I am currently pursuing a Bachelor of Computer Applications (BCA) degree at Maa Shakumbari University, located in the vibrant city of Saharanpur. My academic journey in this program has been a remarkable experience, as I delve into various aspects of computer science and applications.",
  },
 
  {
    id: 6,
    company: "Web Development",
    yearTime: "JUN 2022 - NOW",
    para: "Dynamic Frontend Developer with a Computer Science degree, skilled in ReactJS, JavaScript, HTML, CSS3, Bootstrap, a TailwindCSS. Passionate about user-friendly web experiences and innovative problem-solving. Eager to contribute and grow in frontend development. Knowledge  in server-side like Nodejs, Mongodb, APIs",
  },
];

// PROJCETS COMPONENT
export const ProjectsCard = [
  {
    id: 1,
    img: jantacons,
    title: "JANTA CONSTRUCTION WEBSITE ",
    link:"https://jantaconstruction.com/",
    discription: "I created a website for building construction using HTML, CSS, and JavaScript.  I gained valuable experience in web development, honing my skills in front-end technologies.",
  },
  {
    id: 2,
    img: homedoors,
    title: "HOME DOORS ECOMMERCE WEBSITE",
    link:"https://jantadoors.com/",
    discription: "I designed a website for a Home Doors Manufacturing company using HTML, CSS, and JavaScript, and the experience gained from this endeavor has been immensely rewarding. The website seamlessly combines functionality and aesthetics to showcase the company's ...........",
  },
  {
    id: 3,
    img: webdeveloper,
    title: "PERSONAL PORTFOLIO WEB PAGE",
    link:"https://abu-azhar.netlify.app/",
    discription: "I created my own portfolio website using React.js and Node.js, and the experience gained from developing this site has been both insightful and personally rewarding. Leveraging React.js allowed me to craft a dynamic and visually appealing user interface, showcasing my skills and projects in an engaging manner. ",
  },
  {
    id: 4,
    img: chatapp,
    title: "REAL TIME CHAT APPLICATION ",
    link:"https://online-chatapp.netlify.app/",
    discription: "I developed a Chat App using React.js, Node.js, and Firebase, and the experience gained from creating this application has been incredibly enriching. The use of React.js allowed for the construction of a responsive and dynamic user interface, enhancing the overall user experience.",
  },
  {
    id: 5,
    img: rishtewale,
    title: "MATRIMONIAL WEBSITE rishtewale.com",
    link: "http://rishtewale.com/" ,
    discription: "I created a Matrimonial website using HTML, CSS, and JavaScript, and the experience gained from developing this platform has been both insightful and rewarding. ",
  },
  {
    id: 6,
    img: zenith,
    title: "ZENITH TOBACCO MACHNERY ",
    link:"https://ztm.co.in/",
    discription: "I crafted a website for a company specializing in the sale of cigarette-making machinery on an international scale, utilizing HTML, CSS, and JavaScript in the coding process. This project provided me with a unique and enriching experience.",
  },
];
export const testo = [
  {
    id: 1,
    img: ahmad,
    para: "Thank you for the seamless project delivery. Your professionalism and communication made the process enjoyable. Highly recommended",
    title: "Shuy'eb Ahmad",
    discription: "Social Media Marketing",
  },
  {
    id: 2,
    img: zoyef,
    para: "Outstanding work! The project exceeded my expectations. Your attention to detail and commitment to quality are truly commendable.",
    title: "ZOYEF AHMAD",
    discription: "Frontend Developer",
  },
  {
    id: 3,
    img: usman,
    para: "Top-notch work! Your technical skills and responsiveness made this experience remarkable. Excited to work together again.",
    title: "USMAN EZAZI",
    discription: "Trader",
  },
  {
    id: 4,
    img: wasif,
    para: "Thank you for your hard work and commitment. The project was a success, and your adaptability to changes was invaluable.",
    title: "WASIF GOUR",
    discription: "Software Engineer",
  },
];
// CONTECT COMPONENT
export const addRess = [
  {
    id: 1,
    title: "Our Address",
    addre: "Address : Saharanpur Uttar Pardesh",
    address: "India",
  },
  {
    id: 2,
    title: "Our Phone",
    addre: "Phone Num :+91 7454961965    Pin Code : 247001",
    address: "India",
  },
  {
    id: 3,
    title: "Our Email",
    addre: "Email : 74abuazhar@gmail.com",
    address: "India",
  },
];

export const imges = [
  {
    id: 1,
    img: AbuAzhar,
  },
  {
    id: 2,
    img: about,
  },
  {
    id: 3,
    img: resume,
  },
  {
    id: 4,
    img: project,
  },
  {
    id: 5,
    img: contact,
  },
];
